import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';


Snappy.Component.MeetingsEvents = class MeetingsEvents extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-meeting-events';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.eventSelect = document.getElementById('ws-event-type');
        this.guestSelect = document.getElementById('ws-guests');
    }

    addEventListeners() {
        this.eventSelect.addEventListener('change', this.filterItems.bind(this));
        this.guestSelect.addEventListener('change', this.filterItems.bind(this));
    }

    filterItems() {
        const roomItem = document.getElementsByClassName('fa-filter-content__item');
        var eventTypeFilter = document.getElementById("ws-event-type").value;
               
        for (var i = 0; i < roomItem.length; i++) {            
            if (document.getElementById('ws-event-type').selectedIndex == 0 || roomItem[i].getAttribute('data-event-capacity').includes(eventTypeFilter)) {
                if (document.getElementById('ws-guests').selectedIndex == 0 || this.filterByGuest(roomItem[i].getAttribute('data-event-capacity'), eventTypeFilter, $(roomItem[i]).find('h2').html())) {                    
                    roomItem[i].classList.remove('hidden');
                }
                else {
                    roomItem[i].classList.add('hidden');
                }
            }
            else {
                roomItem[i].classList.add('hidden');
            }
        }

        this.updateCounter();
    }

    filterByGuest(dataeventcapacity, eventTypeFilter, roomName) {
        var eventTypes = dataeventcapacity.split('&')
        var min = parseInt(document.getElementById("ws-guests").value.split('-')[0]);
        var max = parseInt(document.getElementById("ws-guests").value.split('-')[1]);

        for (var i = 0; i < eventTypes.length; i++) {
            var guests = parseInt(eventTypes[i].split('=')[0]);            
            if ((eventTypeFilter == 0 || eventTypes[i].split('=')[1] == eventTypeFilter) &&  (guests >= min && guests <= max)) {
                return true;
            }            
        }

        return false;
    }

    updateCounter() {
        var itemCount = $('.fa-filter-content__item:not(.hidden)').length;

        if (itemCount > 0) {
            $('.counter').html(itemCount + ' Rooms Available');
        } else {
            $('.counter').html('Sorry there are no rooms available for your selected filter')
        } 
    }

    render() {
        this.updateCounter();
        this.setVars();
        this.addEventListeners();
    }
}



// WEBPACK FOOTER //
// ./components/ws-meetings-events/scripts/meetings-events.js